import { useState , useEffect} from 'react';
import axios from 'axios';

export const useFetchStation = () => {
    const [stationList, setStationList] = useState([]);
    const [isLoading , setIsLoading] = useState(false);
    
    useEffect(() => {
        const fetchRequest = async ()  =>{
            setIsLoading(true);

            //JSON取得
            axios.get('/assets/json/stationData.json?'+(new Date()).getTime())
                .then(res => {
                    const data = JSON.parse(JSON.stringify(res.data));
                    setStationList(data.list);
                })
                //.catch(() => setIsError(true))
                .finally(() => setIsLoading(false));
        }
        fetchRequest();
    }, []); 

    return {stationList , isLoading };
}
